import { render, staticRenderFns } from "./addDYForm.vue?vue&type=template&id=12965d26&scoped=true&"
import script from "./addDYForm.vue?vue&type=script&lang=js&"
export * from "./addDYForm.vue?vue&type=script&lang=js&"
import style0 from "./addDYForm.vue?vue&type=style&index=0&id=12965d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12965d26",
  null
  
)

export default component.exports